<template>
	<div>
		<Header title="查看邀请的人" @back="onBack(false)"></Header>
		<a-spin :spinning="loading">
			<!-- <a-form ref="form" :model="formState" name="form" @finish="onSearch">
				<a-row>
					<a-form-item class="ui-form__item" label="会员昵称" name="name">
						<a-input placeholder="请输入会员昵称"></a-input>
					</a-form-item>
					
					<a-form-item class="ui-form__item" label="会员手机号" name="name">
						<a-input placeholder="请输入会员手机号"></a-input>
					</a-form-item>
					
					<a-form-item class="ui-form__item" label="分销等级" name="name">
						<a-select style="width: 190px;" placeholder="请选择分销等级"></a-select>
					</a-form-item>
				</a-row>
				
				<a-row>
					<a-col :span="18">
					</a-col>
					<a-col :span="6" style="text-align: right;">
						<a-button style="margin-right: 10px" type="primary" html-type="submit">搜索</a-button>
						<a-button @click="reset">重置</a-button>
					</a-col>
				</a-row>
			</a-form>		 -->	
			
			<div style="margin-top: 20px;">
				<a-table :pagination="pagination" rowKey="id" :columns="columns" :dataSource="list">
					<template #bodyCell="{ column, record }">
						<template v-if="column.key === 'distributionTime'">
							{{ transDateTime(record.distributionTime)}}
						</template>
					</template>
				</a-table>
			</div>
		</a-spin>
	</div>
</template>

<script>
	import Header from '@/components/header/header.vue';
	import { Icon } from '@/components/icon/icon.js';
	import { getSonTree } from '@/service/modules/distribution.js';
	export default {
		components: {Header,Icon},
		props: {
			id: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				loading: false,
				formState: {},
				searchData: {},
				showModal: false,
				list: [],
				columns: [{ 
					title: '会员昵称',
					dataIndex: 'nickname'
				}, {
					title: '会员手机号',
					dataIndex: 'phone'
				}, {
					title: '注册时间',
					key: 'distributionTime'
				},],
				pagination: {
					showSizeChanger: true,
					showQuickJumper: true,
					size: "middle",
					showTotal: (total) => {
						return "共 " + total + " 条";
					},
					total: 0,
					current: 1,
					pageSize: 10,
					onChange: (page) => {
						this.pagination.current = page;
						this.getData();
					},
					onShowSizeChange: (page, pageSize) => {
						this.pagination.current = 1;
						this.pagination.pageSize = pageSize;
						this.getData();
					}
				},
			}
		},
		created() {
			this.getData();
		},
		methods: {
			onBack(isRef) {
				this.$emit('back', isRef);
			},
			onSearch() {
				this.pagination.current = 1;
				// //this.pagination.pageSize = 10;
				this.searchData = JSON.parse(JSON.stringify(this.formState));
				this.getData();
			},
			reset() {
				this.$refs.form.resetFields();
				this.onSearch();
			},
			async getData() {
				this.loading = true;
				try {
					let ret = await getSonTree({
						page: this.pagination.current,
						pageSize: this.pagination.pageSize,
						id: this.id
					})
					this.loading = false;
					if (ret.code === 200) {
						this.pagination.total = ret.data.totalCount;
						this.list = ret.data.list;
					}
				} catch(e) {
					this.loading = false;
				}
			},
			onAdd() {
				this.showModal = true;
				this.$nextTick(() => {
					this.$refs.addForm.resetFields();
				});
			},
		}
	}
</script>

<style scoped>
	.ui-form__item {
		margin-right: 30px;
	}
</style>
